import React, { useState } from "react";
import { connect } from "react-redux";
import { Redirect, HashRouter, Link } from 'react-router-dom';
import { setRoomControlPage } from '../../layout2.0/action/action'
import { setHcommerceWidget } from '../../layout2.0/action/hCommerce2';
import { setRegPage, currentWidget, setMobileTVPage } from '../../action/action'
import { setRedirectInfo } from "../../layout2.0/action/homeAction";
import { setOpenExternalLinkInSameTab } from '../../layout2.0/action/homeAction'


const RedirectOnLoad = (props) => {

    let room = localStorage.getItem('room')
    const [redirectPath, setRedirectPath] = useState("")
    // {"path": "/hcommerce2","storeSku": "000004","tab":"2"}
    // {"path":"/GuestRequest2","storeSku":"3","tab":"1"}
    
    const { redirectInfo, widgetList } = props;

    console.log("in redirectOnLoad")
    console.log(props.widgetList)
    console.log(redirectInfo)

    const setRoomControlPageOnClick = (widget) => {
        switch (widget.widgetType) {
            case "Room Theme":
                props.setRoomControlPage("roomTheme");
                break;
            case "Room Temperature":
                props.setRoomControlPage("AcControl");
                break;
            case "Speaker":
                props.setRoomControlPage("speakerControl");
                break;
            case "Smart Window Control":
                props.setRoomControlPage("windowTintControl");
                break;
            default:
                console.log("no room control path is matching.")
                break;
        }
    }

    const onWidgetLoad = async (widget) => {

        console.log("current widget", widget)

        if (widget.path) {

            await props.currentWidget(widget);
            setRedirectPath(widget.path)
            if (((room && room != "null") || widget.path == "/checkin/id")) props.setRedirectInfo({})

            if (widget.path === "/RoomControl2") {
                setRoomControlPageOnClick(widget);
            }
            if (widget.path === "/mobileTv") {
                if (room && room != "null") {
                    props.setMobileTVPage(true);
                } else {
                    props.setRegPage(true)
                }
            }
            if (widget.path === "/hcommerce2") {
                props.setHcommerceWidget(widget);
            }
        }
    }

    React.useEffect(() => {
        if (redirectInfo && redirectInfo.path && widgetList.length > 0) {
            widgetList.forEach(widgets => {
                widgets.widgets.forEach(widget => {
                    widget.subWidgetMap.forEach(iterator => {
                        if (iterator.path === redirectInfo.path) {
                            if ((redirectInfo.path.toLowerCase() === "/hcommerce2" || redirectInfo.path.toLowerCase() === "/guestrequest2")){
                                if(redirectInfo.storeSku === iterator.storeSku) onWidgetLoad(iterator);
                                return;
                            }
                            if (redirectInfo.path.toLowerCase() === "/roomcontrol2") {
                                if(redirectInfo.widgetType === iterator.widgetType) onWidgetLoad(iterator);
                                return;
                            }
                            onWidgetLoad(iterator);
                        }
                    });
                });
            });
        }
    }, [redirectInfo, widgetList]);

    return (
        <>
            {redirectPath && (
                <HashRouter>
                    <Redirect exact to={redirectPath} />
                </HashRouter>
            )}
        </>
    )
}

const mapStateToProps = state => {
    return {
        widgetList: state.store2.sideNavBar.widgetList,
        redirectInfo: state.store2.redirectInfo,
    }
}

export default connect(mapStateToProps, { setHcommerceWidget, setRoomControlPage, currentWidget, setRegPage, setMobileTVPage, setRedirectInfo, setOpenExternalLinkInSameTab })(RedirectOnLoad);